import { render, staticRenderFns } from "./FlightMobile.vue?vue&type=template&id=218d8d71&scoped=true&"
import script from "./FlightMobile.vue?vue&type=script&lang=js&"
export * from "./FlightMobile.vue?vue&type=script&lang=js&"
import style0 from "./FlightMobile.vue?vue&type=style&index=0&id=218d8d71&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218d8d71",
  null
  
)

export default component.exports